import { createStore, applyMiddleware } from "redux";
import { activityReducers } from "../reducers/index";
import thunk from "redux-thunk";
import { combineReducers } from "redux";
import storeSynchronize from 'redux-localstore';


const rootReducer = combineReducers({
  collectorActivities: activityReducers
});

const store = createStore(
  rootReducer, applyMiddleware(thunk)
);

// console.log(store.getState());

export default store;


storeSynchronize(store);
